import styled from 'styled-components';
import {
  Accordion as BaseAccordion,
  AccordionItem as BaseAccordionItem,
  AccordionPanel as BaseAccordionPanel,
} from '@reach/accordion';
import {
  DESKTOP_MIN_BREAK,
  TABLET_BREAK,
  GTM_DATA_ATTRIBUTE,
  PHONE_BREAK,
} from '#/shared/constants';
import AlertsIconBase from '#/shared/components/GeneratedIcons/trimet/AlertSolid';
import { ClearButton, ClearLink } from '#/shared/components/Styled';

export const SignListAccordion = styled(BaseAccordion)`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: ${DESKTOP_MIN_BREAK};
  padding: 8px;
`;

export const SignRowAccordionItem = styled(BaseAccordionItem)`
  background-color: ${props => props.theme.secondaryBackgroundColor};
  border: 1px solid ${props => props.theme.tertiaryColor};
  border-radius: 5px;
  margin: 2px 0;
  transition: ${props => props.theme.boxShadowTransition};
  &[data-reach-accordion-item][data-state='open'] {
    box-shadow: ${props => props.theme.boxShadowCardHover};
  }
  @media (any-hover: hover) {
    &:hover {
      box-shadow: ${props => props.theme.boxShadowCardHover};
    }
  }
  &:focus,
  &:active {
    background-color: transparent;
  }
`;

export const AlertWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const AlternativeMessage = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  background-color: ${props => props.theme.secondaryBackgroundColor};
  border: 1px solid ${props => props.theme.tertiaryColor};
  border-radius: 5px;
  margin: 2px 0;
  padding: 10px;
`;

export const StopSignListAlternativeMessage = styled.div`
  flex: 1 0 auto;
  padding: 10px;
  margin: 0 0 1em 0;
  max-width: 500px;
`;

export const NoArrivalMessage = styled(StopSignListAlternativeMessage)`
  text-align: center;
  @media (min-width: ${PHONE_BREAK}) {
    text-align: left;
  }
`;

export const AlertsMessageContainer = styled(StopSignListAlternativeMessage)`
  display: flex;
  justify-content: center;
`;

export const AlertsMessageTextAlignment = styled.div``;

export const AccordionPanel = styled(BaseAccordionPanel)`
  border-radius: 0 0 5px 5px;
  overflow: hidden;
  &:focus {
    outline: 0;
  }
`;

export const IconWrapper = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  align-items: center;
  justify-self: flex-end;
  justify-content: center;
  margin: 0 5px;
  @media (min-width: ${TABLET_BREAK}) {
    height: 60px;
  }
  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    height: 70px;
  }
`;

export const AlertsIcon = styled(AlertsIconBase).attrs(({ theme }) => ({
  height: '80%',
  width: '80%',
  fill: theme.baseAlertBackgroundColor,
}))``;

export const ButtonWrap = styled.div`
  display: flex;
  flex: 0 0 auto;
  margin: 0 auto 10px;
  min-width: 300px;
  max-width: 400px;
`;

export const SeeNearbyServiceButton = styled(ClearButton)`
  flex: 0 1 auto;
  min-width: 0;
  font-size: 1em;
  font-weight: bold;
  color: ${props => props.theme.secondaryFontColor};
  margin: 0 0 0 7px;
  padding: 5px;
`;
export const OrWrapper = styled.div`
  flex: 0 1 auto;
  padding: 0 10px;
  align-self: center;
  margin: 0 0 10px 0;
`;

export const WithStopsHelper = styled.div`
  margin: 1em 0 0 0;
  align-self: center;
`;

export const AlertMoreLink = styled(ClearLink).attrs(({ dataGtm }) => ({
  [GTM_DATA_ATTRIBUTE]: dataGtm,
  target: '_blank',
}))`
  background-color: transparent;
  color: ${props => props.theme.inverseFontColor3};
  opacity: ${props => props.theme.initialButtonOpacity};
  text-decoration: underline;
  @media (any-hover: hover) {
    &:hover {
      opacity: 1;
      text-decoration: none;
      background-color: transparent;
    }
  }
`;
